import { styled, Flex, Box } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const Wrapper = styled(Box)`
  border-radius: 12px;
  border: 1px solid #efe9fb;
  background: #fff;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;

  ${(props) => props.styles}
`;

export const Header = styled(Box)`
  padding: 12px 16px;
  align-items: center;
  background: #F7F6FF;
  box-sizing: border-box;
`;


export const MakeModel = styled(Text)`
  color: #040222;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

export const RegNumber = styled(Text)`
  color: #36354c;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;

export const Content = styled(Flex)`
  flex-direction: column;
  box-sizing: border-box;
  border: 1px solid rgb(231, 231, 240);
  border-radius: 8px;
  padding: 12px 16px 16px;
  margin-top: 16px;
`;

export const Variant = styled(Text)`
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;

export const FieldValueWrapper = styled(Flex)`
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
`;

export const Field = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #5b5675;
`;

export const Value = styled(Text)`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #040222;
`;

export const ContentHeader = styled(Flex)`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: -36px
`;
